export default class StickyHeader {
  constructor() {
    this.header = document.querySelector('.main-header');
    this.preHeader = document.querySelector('.pre-header');

    /**
     * Should go sticky only if not mobile.
     * On mobile the header is fixed by default.
     */
    if (window.innerWidth > 768) {
      this.compute();

      // Add class and change size on scroll
      window.addEventListener('scroll', () => {
        this.stickHeader();
      });
    }
  }

  /**
   * Compute differents heights, distance, etc...
   */
  compute() {
    const preHeaderStyles = window.getComputedStyle(this.preHeader);
    const preHeaderMarginTop = parseInt(preHeaderStyles.marginTop, 10);
    const preHeaderMarginBottom = parseInt(preHeaderStyles.marginBottom, 10);
    const preHeaderHeight = this.preHeader.offsetHeight;

    this.preheaderOutterHeight = preHeaderHeight + preHeaderMarginTop + preHeaderMarginBottom;
    this.headerHeight = this.header.offsetHeight;

    this.header.classList.add('is-sticky');
    this.stickyHeaderHeight = this.header.offsetHeight;
    this.header.classList.remove('is-sticky');

    // Process only if the racquet element is on the page
    if (this.racquet) {
      this.racquetHeight = this.racquet.offsetHeight;
      this.racquetThreshold = this.racquet.offsetTop - this.stickyHeaderHeight;
    }
  }

  /**
   * Stick/unstick header depending on vertical scroll position
   * When top of the viewport meet top of header, add a is-sticky class to it
   */
  stickHeader() {
    if (window.scrollY > this.preheaderOutterHeight) {
      this.header.classList.add('is-sticky');
      // Add extra margin to preheader to compensate header
      // that went out of the page flow by being sticky
      // Thus avoiding "page jump" effect
      this.preHeader.style.marginBottom = `${this.headerHeight}px`;
    } else {
      this.header.classList.remove('is-sticky');
      // Remove extra margin added when header became sticky
      this.preHeader.style.removeProperty('margin-bottom');
    }
  }
}
